import { isNull } from 'lodash';
import React, { useContext } from 'react';
import withRouter from 'react-router-dom/withRouter';
import { ThemeContext } from 'styled-components';
import axios from 'axios';
import { API_HOST } from '../consts';
import ParticipaçãoDreTable from '../components/ParticipacaoDreTable';

const ParticipacaoDreColumn = ({ boletimaluno, hideHeader, ...rest }) => {
  const theme = useContext(ThemeContext);
  const [dreOrDr, setDreOrDr] = React.useState('DRE');

  React.useEffect(() => {
    axios
      .get(`${API_HOST}/params/param?model=avalia`)
      .then((response) => {
        const metadataAvalia = {};
        response.data.forEach((m) => {
          metadataAvalia[`${m.model}.${m.name}`] = m.value;
        });
        if ((metadataAvalia['avalia.estado'] || '').toLowerCase() === 'rj') {
          setDreOrDr('DRP');
        }
      })
      .catch(() => {});
  }, []);

  const redeOrDn = 'Rede de Ensino'

  const dadosTable = {
    next: null,
    previous: null,
    count: 0,
    total_pages: 1,
    results: [
      {
        name: 'Estudante',
        pontuacao: !boletimaluno.NT_ALUNO ? '-' : boletimaluno.NT_ALUNO,
        nivel: !boletimaluno.NT_ALUNO ? '-' : boletimaluno.proficiencia_aluno,
        status: !boletimaluno.NT_ALUNO
          ? '-'
          : boletimaluno.proficiencia_aluno
          ? boletimaluno.status_proficiencia_ano[
              boletimaluno.proficiencia_aluno
            ]
          : '-'
      },
      {
        name: dreOrDr,
        pontuacao: !boletimaluno.NT_DRE ? '-' : boletimaluno.NT_DRE,
        nivel: !boletimaluno.NT_DRE ? '-' : boletimaluno.proficiencia_dre,
        status: !boletimaluno.NT_DRE
          ? '-'
          : boletimaluno.proficiencia_dre
          ? boletimaluno.status_proficiencia_ano[boletimaluno.proficiencia_dre]
          : '-'
      },
      {
        name: redeOrDn,
        pontuacao: !boletimaluno.NT_REDE ? '-' : boletimaluno.NT_REDE,
        nivel: !boletimaluno.NT_REDE ? '-' : boletimaluno.proficiencia_rede,
        status: !boletimaluno.NT_REDE
          ? '-'
          : boletimaluno.proficiencia_rede
          ? boletimaluno.status_proficiencia_ano[boletimaluno.proficiencia_rede]
          : '-'
      },

      {
        name: 'Escola',
        pontuacao: !boletimaluno.NT_ESCOLA ? (
          '-'
        ) : (
          <div
            style={{
              border: 'none',
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {boletimaluno.NT_ESCOLA}
          </div>
        ),
        nivel: !boletimaluno.NT_ESCOLA ? '-' : boletimaluno.proficiencia_escola,
        status: !boletimaluno.NT_ESCOLA
          ? '-'
          : boletimaluno.proficiencia_escola
          ? boletimaluno.status_proficiencia_ano[
              boletimaluno.proficiencia_escola
            ]
          : '-'
      }
    ]
  };

  const columns = [
    {
      Header: () => (
        <span style={{ display: 'flex', justifyContent: 'end' }}>
          Proficiência
        </span>
      ),
      headerStyle: {
        color: 'white',
        'border-top-left-radius': '10px',
        'border-bottom-left-radius': '10px',
        'border-lef': '10px',
        'background-color': `${theme.primary}`
      },
      columns: [
        {
          accessor: 'name',
          className: 'd-flex justify-content-center align-items-center',
          width: 150
        },
        {
          accessor: 'pontuacao',
          className: 'd-flex justify-content-center align-items-center'
        }
      ],
      sortable: false,
      className: 'd-flex justify-content-center align-items-center'
    },
    {
      Header: 'Nível',
      headerStyle: {
        color: 'white',
        'border-top-right-radius': '10px',
        'border-bottom-right-radius': '10px',
        'border-lef': '10px',
        'background-color': `${theme.primary}`
      },
      columns: [
        {
          accessor: 'nivel',
          className: 'd-flex justify-content-center align-items-center',
          width: 150
        },
        {
          accessor: 'status',
          className: 'd-flex justify-content-center align-items-center'
        }
      ],
      sortable: false,
      className: 'd-flex justify-content-center align-items-center'
    }
  ];

  return (
    <div style={{ width: '50%', marginTop: '3.2rem' }}>
      <ParticipaçãoDreTable columns={columns} data={dadosTable} {...rest} />
    </div>
  );
};

export default withRouter(ParticipacaoDreColumn);
